// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.em-tooltip {
    font-family: Arial;
    color: #383838;
    max-width: 300px;
    overflow: hidden;
    background: white;
    padding: 0px;
    border: 0px;
    border-radius: 0px;
    box-shadow:
        0px 4px 6px rgba(0, 0, 0, 0.1),
        0px 1px 3px rgba(0, 0, 0, 0.08);
    position: absolute;
    font-family: Helvetica, Arial, sans-serif;
    pointer-events: none;
    z-index: 99999999;
}
.em-tooltip-text {
    background: #ffffff;
    padding: 4px;
    font-size: 15px;
}
.em-tooltip-bar {
    background: #515560;
    color: #ffffff;
    padding: 6px;
    font-size: 16px;
}

.em-footnote-tooltip {
    background: #ffffff;
    padding: 4px;
    font-size: 12px;
}
.em-tooltip-table {
    margin: 0px;
}
.em-tooltip-piechart-container {
    text-align: center;
    fill: #383838;
    display: flex;
    justify-content: center;
}
.em-tooltip-breakdown {
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-size: 13px;
    line-height: 1.2;
    padding: 10px;
    padding-top: 3px;
}

.em-breakdown-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.em-breakdown-color {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 6px;
    flex-shrink: 0;
}

.em-breakdown-label {
    flex: 1;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.em-breakdown-value {
    margin-left: 8px;
    font-weight: 500;
    color: #222;
    white-space: nowrap;
}

.em-breakdown-item.em-total {
    border-top: 1px solid #ccc;
    margin-top: 3px;
    padding-top: 3px;
    font-weight: bold;
}

.em-cx-breakdown-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.em-tooltip-cx {
    line-height: 1;
    padding: 0px;
}

.em-tooltip-cx .em-breakdown-value,
.em-tooltip-cx .em-breakdown-label,
.em-tooltip-cx .em-breakdown-color {
    margin: 0;
    font-size: 11px; /* Smaller text for compactness */
    white-space: nowrap;
}

.em-tooltip-cx-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
}

.em-tooltip-cx-table th,
.em-tooltip-cx-table td {
    padding: 2px 4px; /* Minimal padding */
    border: 1px solid #eee;
}

.em-tooltip-cx-table th {
    background: #f7f7f7;
    font-weight: bold;
    font-size: 11px;
}

.em-tooltip-cx-table td {
    font-size: 11px;
    white-space: nowrap;
}

/* Make the Total value bold and right-aligned */
.em-tooltip-cx-table .em-total td[colspan] {
    text-align: right;
    font-weight: bold !important;
}

/* Also make the inner number span bold */
.em-tooltip-cx-table .em-total td[colspan] .em-breakdown-value {
    font-weight: bold !important;
}
.em-total {
    font-weight: bold !important;
}

.em-tooltip-cx-table td {
    text-align: right;
}
.em-tooltip-cx-table td:first-child {
    text-align: left;
}
.em-tooltip-cx-table th {
    text-align: right;
}
.em-tooltip-cx-table th:first-child {
    text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/css/tooltip.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB;;uCAEmC;IACnC,kBAAkB;IAClB,yCAAyC;IACzC,oBAAoB;IACpB,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;;;IAGI,SAAS;IACT,eAAe,EAAE,iCAAiC;IAClD,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB,EAAE,oBAAoB;IACtC,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA,gDAAgD;AAChD;IACI,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA,yCAAyC;AACzC;IACI,4BAA4B;AAChC;AACA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB","sourcesContent":[".em-tooltip {\r\n    font-family: Arial;\r\n    color: #383838;\r\n    max-width: 300px;\r\n    overflow: hidden;\r\n    background: white;\r\n    padding: 0px;\r\n    border: 0px;\r\n    border-radius: 0px;\r\n    box-shadow:\r\n        0px 4px 6px rgba(0, 0, 0, 0.1),\r\n        0px 1px 3px rgba(0, 0, 0, 0.08);\r\n    position: absolute;\r\n    font-family: Helvetica, Arial, sans-serif;\r\n    pointer-events: none;\r\n    z-index: 99999999;\r\n}\r\n.em-tooltip-text {\r\n    background: #ffffff;\r\n    padding: 4px;\r\n    font-size: 15px;\r\n}\r\n.em-tooltip-bar {\r\n    background: #515560;\r\n    color: #ffffff;\r\n    padding: 6px;\r\n    font-size: 16px;\r\n}\r\n\r\n.em-footnote-tooltip {\r\n    background: #ffffff;\r\n    padding: 4px;\r\n    font-size: 12px;\r\n}\r\n.em-tooltip-table {\r\n    margin: 0px;\r\n}\r\n.em-tooltip-piechart-container {\r\n    text-align: center;\r\n    fill: #383838;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.em-tooltip-breakdown {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 2px;\r\n    font-size: 13px;\r\n    line-height: 1.2;\r\n    padding: 10px;\r\n    padding-top: 3px;\r\n}\r\n\r\n.em-breakdown-item {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.em-breakdown-color {\r\n    width: 8px;\r\n    height: 8px;\r\n    border-radius: 50%;\r\n    display: inline-block;\r\n    margin-right: 6px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.em-breakdown-label {\r\n    flex: 1;\r\n    color: #333;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.em-breakdown-value {\r\n    margin-left: 8px;\r\n    font-weight: 500;\r\n    color: #222;\r\n    white-space: nowrap;\r\n}\r\n\r\n.em-breakdown-item.em-total {\r\n    border-top: 1px solid #ccc;\r\n    margin-top: 3px;\r\n    padding-top: 3px;\r\n    font-weight: bold;\r\n}\r\n\r\n.em-cx-breakdown-item {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.em-tooltip-cx {\r\n    line-height: 1;\r\n    padding: 0px;\r\n}\r\n\r\n.em-tooltip-cx .em-breakdown-value,\r\n.em-tooltip-cx .em-breakdown-label,\r\n.em-tooltip-cx .em-breakdown-color {\r\n    margin: 0;\r\n    font-size: 11px; /* Smaller text for compactness */\r\n    white-space: nowrap;\r\n}\r\n\r\n.em-tooltip-cx-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    table-layout: fixed;\r\n}\r\n\r\n.em-tooltip-cx-table th,\r\n.em-tooltip-cx-table td {\r\n    padding: 2px 4px; /* Minimal padding */\r\n    border: 1px solid #eee;\r\n}\r\n\r\n.em-tooltip-cx-table th {\r\n    background: #f7f7f7;\r\n    font-weight: bold;\r\n    font-size: 11px;\r\n}\r\n\r\n.em-tooltip-cx-table td {\r\n    font-size: 11px;\r\n    white-space: nowrap;\r\n}\r\n\r\n/* Make the Total value bold and right-aligned */\r\n.em-tooltip-cx-table .em-total td[colspan] {\r\n    text-align: right;\r\n    font-weight: bold !important;\r\n}\r\n\r\n/* Also make the inner number span bold */\r\n.em-tooltip-cx-table .em-total td[colspan] .em-breakdown-value {\r\n    font-weight: bold !important;\r\n}\r\n.em-total {\r\n    font-weight: bold !important;\r\n}\r\n\r\n.em-tooltip-cx-table td {\r\n    text-align: right;\r\n}\r\n.em-tooltip-cx-table td:first-child {\r\n    text-align: left;\r\n}\r\n.em-tooltip-cx-table th {\r\n    text-align: right;\r\n}\r\n.em-tooltip-cx-table th:first-child {\r\n    text-align: left;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
